import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M11.5 0L5.98 5.519c2.879.098 5.135 1.053 6.059 2.481H13v5.981h5V6.499L11.5 0zm-6 13.5c-2.261 0-4.175-.524-5.427-1.388A1.185 1.185 0 0 0 0 12.5C0 13.881 2.462 15 5.5 15s5.5-1.119 5.5-2.5c0-.132-.029-.261-.073-.388C9.675 12.976 7.761 13.5 5.5 13.5zm0 3c-2.261 0-4.175-.524-5.427-1.388A1.185 1.185 0 0 0 0 15.5C0 16.881 2.462 18 5.5 18s5.5-1.119 5.5-2.5c0-.132-.029-.261-.073-.388C9.675 15.976 7.761 16.5 5.5 16.5zm0-9.5C2.462 7 0 8.119 0 9.5S2.462 12 5.5 12 11 10.881 11 9.5 8.538 7 5.5 7z" />
  </svg>
);

export default SvgComponent;
